import {Component, OnInit} from '@angular/core';
import {NgForOf, NgIf} from '@angular/common';
import {MetaTitle} from '../../../../decorator/meta-title';
import {Report} from '../../../../models/statistic/report';
import {StatisticService} from '../../../../services/statistic/statistic.service';
import {LoaderService} from '../../../../services/loader/loader.service';
import {PercentPipe} from '../../../../pipes/percent/percent.pipe';
import {MoneyPipe} from '../../../../pipes/money/money.pipe';

@Component({
  selector: 'app-offer-report',
  imports: [
    NgIf,
    NgForOf,
    PercentPipe,
    MoneyPipe
  ],
  templateUrl: './offer-report.component.html',
  styleUrl: './offer-report.component.scss'
})
@MetaTitle('Offer Report')
export class OfferReportComponent implements OnInit {

  statistics: Report[] = [];

  constructor(
    protected loader: LoaderService,
    private statisticService: StatisticService
  ) {
  }

  ngOnInit(): void {
    this.loader.startLoading();
    this.statistics = [];

    this.statisticService.$filters.subscribe((filters: any) => {
      this.statisticService.fetchBasicReport('offer', filters).subscribe((statistics: Report[]) => {
        this.statistics = statistics;
        this.loader.stopLoading();
      });
    });
  }

}
